module.exports = __webpack_public_path__ + "static/img/rank_305.a064581.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_305.png
// module id = QIpd
// module chunks = 0